export enum SearchSortTypeOrdinal {
  Default,
  Inbound,
  Rrp,
  Wsp,
  Markup,
  Category,
  ArticleTitle,
  ArticleNumberAttribute,
  Stock,
  Availability,
  IsdDate,
  MostPopularVariants,
  BoughtThisSeason,
  New,
  DiscountPercentage,
}
